import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import ServiceDetail from "@/pages/ServiceDetail";
import BookingFlow from "@/pages/BookingFlow";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancelled from "@/pages/BookingCancelled";
import BookingsList from "@/pages/BookingsList";
import { ScrollToHash } from "@/components/ScrollToHash";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/book/:tierId" element={<BookingFlow />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/cancelled" element={<BookingCancelled />} />
          <Route path="/bookings" element={<BookingsList />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
